import { cva } from "class-variance-authority";

const headerContainer = cva("inline-block sticky top-0 z-40 bg-[#0A0F16] shadow-sm w-full text-white flex ",{
    variants:{
        type:{
            mobile:"p-6 pt-8 inset-0 -top-2 block lg:hidden",
            desktop:"px-16 xl:px-20 2xl:px-28 py-5 hidden lg:block"
        }
    }
})

export const pageStyle = cva("flex flex-col space-y-10 lg:space-y-14 lg:w-full h-fit lg:pt-[56px] px-6 lg:px-16 xl:px-20 2xl:px-28");

export const headerStyle = {
    headerContainer
}

export const footerStyle = cva("flex flex-col lg:flex-row space-y-8 lg:space-y-0 lg:space-x-24 relative w-full justify-center px-6 lg:px-16 xl:px-20 2xl:px-28 pt-16");

export const footerPoints = cva("flex flex-col lg:flex-row space-y-8 lg:space-y-0 justify-between self-stretch w-full h-full items-start")

export const footerLabels = cva("flex flex-col lg:flex-row space-y-8 lg:space-y-0 lg:space-x-8 p-2 pt-4 pb-20 px-6 lg:py-10 relative w-full z-20 lg:px-16 xl:px-20 2xl:px-28 text-neutral-light-900");

export const titleStyle = cva("flex items-start justify-between ",{
    variants:{
        type:{
            mobile:"p-2 ",
            desktop:"flex items-start md:px-16 2xl:px-20 justify-evenly"
        }
    }
});

export const bodyStyle = cva("flex flex-col gap-6 ");

export const resultStyle = cva("z-50 flex flex-col w-full absolute py-2 text-sm font-normal text-light-neutral-300 bg-primary shadow-lg border border-dark-neutral-300 rounded ",{
    variants:{
        type:{
            mobile:"left-0 mt-8 mx-4 w-[94%]",
            desktop:"mt-2"
        }
    }
})

export const searchResultStyle = cva("flex flex-col w-fit my-2 absolute py-2 text-sm font-normal text-neutral-dark-200 bg-neutral-light-50 shadow-md border border-neutral-200 rounded z-50",
    {
        variants:{
            type:{
                notFound:"w-[15%]"
            }
        }
    }
);

export const navSection = cva("sticky top-[90px] pt-2 lg:top-20 bg-neutral-dark-50 z-10 flex items-center gap-6 w-full lg:pt-5 pb-2 font-poppinsMedium font-medium text-neutral-light-900 text-sm lg:text-lg");

export const navLinkStyle = cva("text-sm lg:text-base border border-neutral-dark-700 shadow-sm rounded-full px-4 py-0.5");

export const dataInsightsWrapper = cva(
    "grid grid-cols-1 lg:grid-cols-12 gap-8 w-full justify-items-stretch pt-6 lg:pt-12"
  );
  
  export const textWrapper = cva(
    "col-span-1 lg:col-span-4 flex flex-col gap-y-4 text-neutral-light-900"
  );
  
  export const imageCardWrapper = cva(
    "col-span-1 lg:col-span-8 gap-6 lg:gap-8",
    {
      variants: {
        type: {
          all: "grid grid-cols-1 md:grid-cols-2",
          default: "",
        },
      },
      defaultVariants: {
        type: "default",
      },
    }
  );
  
  export const swiperClass = cva(
    "custom-swiper1 w-full mb-6 h-full bg-[#0A0E15] rounded-lg overflow-hidden relative"
  );
  
  export const slideContainer = cva(
    "flex flex-col gap-y-4 md:gap-y-6"
  );
  
  export const desktopSlide = cva(
    "hidden md:flex flex-col gap-y-4 md:gap-y-6"
  );

export const footerContainer= cva("flex flex-col justify-between w-[40%] xl:w-[55%] 2xl:w-[70%]");

export const rightsText = cva("hidden md:inline items-end text-[#8C8D8F] font-medium")